import { Button as ButtonElement } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';

export function Button() {
  const { buttonEnabled, buttonLink, buttonStyles, buttonIcon } = useSettings();
  const { value, rawValue, target } = buttonLink;
  const iconOnly = buttonStyles.text === '';

  const handlePress = () => {
    if (value) {
      window.open(rawValue, target);
    }
  };

  if (!buttonEnabled) {
    return null;
  }

  return (
    <ButtonElement
      iconOnly={iconOnly}
      iconLeft={buttonIcon}
      onClick={handlePress}
      {...buttonStyles}
    />
  );
}
